// @TODO: Refine this file and remove the warnings.
export const collectionPanelsTemplate = {
  collectionPanels: {
    render(html, { props }) {
      const { collectionPanels } = props;

      return html`${collectionPanels.map((panel) => {
        const { align, style, row, rowMobile, link, text, buttonLabel, media, subtitle } = panel;

        const renderPanelContent = () => {
          switch (style) {
            case 'image-script':
              return html`
                <div class="collection-panel__text exclude-tagalys-css-reset heading-3xl">
                  ${text}
                  ${link ? html`<a href="${link}" class="collection-panel__link exclude-tagalys-css-reset"></a>` : ''}
                </div>
                <img src="${media}" class="collection-panel__img" />
              `;

            case 'image-text-overlay':
              return html`
                <div class="collection-panel__text exclude-tagalys-css-reset">
                  <div class="heading-4xl exclude-tagalys-css-reset">${text}</div>
                  ${buttonLabel
                    ? html`<a href="${link}" class="button button--secondary button--white exclude-tagalys-css-reset"
                        >${buttonLabel}</a
                      >`
                    : ''}
                  ${link ? html`<a href="${link}" class="collection-panel__link exclude-tagalys-css-reset"></a>` : ''}
                </div>
                <img src="${media}" class="collection-panel__img" />
              `;

            case 'image-text-split-block':
              return html`
                <div class="collection-panel__content-grid">
                  <div class="collection-panel__img-container">
                    <img src="${media}" class="collection-panel__img" />
                  </div>
                  <div class="collection-panel__text exclude-tagalys-css-reset">
                    ${subtitle
                      ? html`
                          <div class="subtitle-block body-sm body-uppercase">
                            <div class="subtitle-block-text">${subtitle}</div>
                          </div>
                        `
                      : ''}
                    <div class="heading-2xl exclude-tagalys-css-reset">${text}</div>
                    ${buttonLabel
                      ? html`<a href="${link}" class="button button--tertiary button--black exclude-tagalys-css-reset"
                          >${buttonLabel}</a
                        >`
                      : ''}
                    ${link ? html`<a href="${link}" class="collection-panel__link exclude-tagalys-css-reset"></a>` : ''}
                  </div>
                </div>
              `;

            case 'image-only':
              return html`<img src="${media}" class="collection-panel__img" />`;

            default:
              return '';
          }
        };

        return html`
          <div
            class="collection-panel collection-panel--${align} collection-panel--${style} exclude-tagalys-css-reset"
            style="--collection-panel-grid-row: ${row}; --collection-panel-grid-row-mobile: ${rowMobile}"
          >
            <div class="collection-panel__content exclude-tagalys-css-reset">
              ${link ? html`<a href="${link}" class="collection-panel__link exclude-tagalys-css-reset"></a>` : ''}
              ${renderPanelContent()}
            </div>
          </div>
        `;
      })}`;
    }
  }
};
